// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1LaWn","header":"ReportDetails_header__3_5fg","title":"ReportDetails_title__3nR0f","left":"ReportDetails_left__oFf3A"};